import { render, staticRenderFns } from "./ReasonsTabs.vue?vue&type=template&id=646c846e&"
import script from "./ReasonsTabs.vue?vue&type=script&lang=js&"
export * from "./ReasonsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports